/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.15.527 on 2019-07-04 14:53:30.

export enum AttributeType {
    BOOLEAN = 'BOOLEAN',
    SELECTION = 'SELECTION',
    NUMERIC = 'NUMERIC',
    MULTISELECTION = 'MULTISELECTION',
    TEXT = 'TEXT',
    DATE = 'DATE',
    NOTE = 'NOTE'
}

export enum AttributeUnit {
    NONE = 'NONE',
    CM = 'CM',
    IN = 'IN',
    KG = 'KG',
    LB = 'LB'
}

export enum CaseStatus {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED'
}

export enum CaseType {
    APPLICATION = 'APPLICATION',
    FORENSIC_AUDIT = 'FORENSIC_AUDIT'
}

export enum DateElement {
    DAY = 'DAY',
    MONTH = 'MONTH',
    YEAR = 'YEAR'
}

export enum DecisionStatus {
    UNKNOWN = 'UNKNOWN',
    UNCONFIRMED = 'UNCONFIRMED',
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    FOR_RECORD = 'FOR_RECORD'
}

export enum DecisionType {
    UNKNOWN = 'UNKNOWN',
    FINAL = 'FINAL',
    INTERIM = 'INTERIM',
    UNDER_AUDIT = 'UNDER_AUDIT'
}

export enum DisclosureSource {
    NONE = 'NONE',
    SEARCH = 'SEARCH',
    SPECIFIED = 'SPECIFIED',
    PICKLIST = 'PICKLIST'
}

export enum DisclosureStatus {
    UNKNOWN = 'UNKNOWN',
    IN_PROGRESS = 'IN_PROGRESS',
    CANCELLED = 'CANCELLED',
    CONFIRMED = 'CONFIRMED',
    ANSWER_LATER = 'ANSWER_LATER',
    ERROR = 'ERROR'
}

export enum EmbeddableResourceNames {
    DISCLOSURES = 'disclosures',
    PHYSICIANS = 'physicians',
    PRIMARY_PHYSICIAN = 'primaryPhysician',
    DISCLOSURE_PHYSICIANS = 'disclosure_physicians',
    AFFECTED_QUESTIONS = 'affectedQuestions',
    LISTS = 'lists'
}

export enum ManualDecisionStatus {
    UNCONFIRMED = 'UNCONFIRMED',
    CONFIRMED = 'CONFIRMED',
    APPROVED = 'APPROVED',
    APPROVED_PENDING_AUTO_FINALIZATION = 'APPROVED_PENDING_AUTO_FINALIZATION',
    FINALIZED = 'FINALIZED'
}

export enum PhysicianAdditionSource {
    CLIENT = 'CLIENT',
    UNDERWRITER = 'UNDERWRITER',
    RX = 'RX'
}

export enum ProcessingStage {
    AUTO_UNDERWRITING = 'AUTO_UNDERWRITING',
    MANUAL_UNDERWRITING = 'MANUAL_UNDERWRITING'
}

export enum QuestionAnswerType {
    YES_NO = 'YES_NO',
    ENTER_DETAILS = 'ENTER_DETAILS',
    PICKLIST = 'PICKLIST'
}

export enum QuestionType {
    HEADING = 'HEADING',
    STANDARD = 'STANDARD',
    CONDITIONAL = 'CONDITIONAL',
    CASE_DATA = 'CASE_DATA'
}

export enum ReflexiveAnswerType {
    BOOLEAN = 'BOOLEAN',
    SELECTION = 'SELECTION',
    NUMBER = 'NUMBER',
    TEXT = 'TEXT',
    DATE = 'DATE',
    PICK_LIST = 'PICK_LIST'
}

export enum ResultType {
    AUTOMATIC = 'AUTOMATIC',
    MANUAL = 'MANUAL'
}

export enum StageDataAccessType {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL'
}

export enum StageType {
    INTERACTIVE = 'INTERACTIVE',
    AUTORUN = 'AUTORUN',
    MATCH = 'MATCH'
}

export enum Type {
    DATE = 'DATE',
    NUMBER = 'NUMBER',
    TEXT = 'TEXT',
    BOOLEAN = 'BOOLEAN'
}
